import React from "react";
import PropTypes from "prop-types";

import Flexbox from "core/Flexbox";
import colors from "core/colors";
import BodyText from "core/BodyText";
import {
    ProgressBarBase,
    CurrentProgressIndicator,
    ProgressBarTextWrapper,
    ProgressArrow
} from "./styles";

const ProgressBar = ({ progressSteps }) => (
    <Flexbox flexDirection="column" alignItems="center">
        <ProgressBarBase>
            <CurrentProgressIndicator />
        </ProgressBarBase>
        <ProgressBarTextWrapper
            alignItems="baseline"
            justifyContent="space-between"
        >
            {progressSteps.map(({ text, isActive }, index) => {
                const renderArrow = index + 1 !== progressSteps.length;

                return (
                    <React.Fragment key={index}>
                        <BodyText
                            type="p"
                            size="md"
                            key={index}
                            copyColor={isActive ? colors.mist : colors.platinum}
                        >
                            {text}
                        </BodyText>
                        {renderArrow && <ProgressArrow />}
                    </React.Fragment>
                );
            })}
        </ProgressBarTextWrapper>
    </Flexbox>
);

ProgressBar.propTypes = {
    progressSteps: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string,
            isActive: PropTypes.bool
        })
    ).isRequired
};

export default ProgressBar;

// To note: ProgressBarBase will need refactor if any progressSteps array has more than 2 items
